import {
  IQuestionModel,
  QuestionAnswerMap
} from '@care-portals/api-interfaces';

const trtEnhancedInitialQuestions = [
  {
    class: 'ineligible',
    field: 'trtEnhanced_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to prescribe for you today",
    type: 'info',
    isLast: true,
    reject: true,
    answer: {},
    extras: { sendToBeluga: false }
  },
  {
    class: 'ineligible',
    field: 'trtEnhanced_didNotConsent',
    label: 'We need your consent to continue',
    subLabel:
      'You did not agree to the terms shown on the previous step. Without that consent, we cannot move forward with your visit or prescribe treatment.',
    type: 'info',
    isLast: true,
    reject: true,
    answer: {},
    extras: { sendToBeluga: false }
  },
  {
    field: 'trtEnhanced_complete',
    isLast: true,
    label:
      'Thank you for completing this questionnaire, please select "Finish" to submit',
    type: 'info',
    answer: {},
    extras: { sendToBeluga: false }
  },
  {
    field: 'trtEnhanced_sexAssignedAtBirth',
    label: 'What was your sex assigned at birth?',
    type: 'select',
    extras: { sendToBeluga: false },
    answer: {
      type: 'single_select',
      options: [
        { value: 'Male', key: 'male' },
        { value: 'Female', key: 'female' }
      ]
    }
  },
  {
    field: 'trtEnhanced_genderIdentity',
    label: 'What is your current gender identity?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Man', key: 'man' },
        { value: 'Woman', key: 'woman' },
        { value: 'Transgender male', key: 'transgender_male' },
        { value: 'Transgender woman', key: 'transgender_woman' },
        { value: 'Non-binary', key: 'non_binary' }
      ]
    }
  },
  {
    field: 'trtEnhanced_fertilityPlan',
    label: 'Which of the following best describes your situation?',
    educationalSlide:
      'Testosterone replacement therapy (TRT) can significantly reduce sperm production and may negatively impact fertility. If you are actively trying to conceive, TRT may not be the most appropriate option.',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            "I understand the risk and I'm not planning on having children and would like to continue with treatment",
          key: 'no_children_continue'
        },
        {
          value:
            'I am planning on having children and would be interested in alternatives such as enclomiphene',
          key: 'planning_children_alternatives'
        },
        {
          value:
            'I AM planning on having children soon and would like to cancel',
          key: 'planning_children_cancel'
        }
      ]
    }
  },
  {
    field: 'trtEnhanced_disqualifyingConditions',
    label: 'Do any of these apply to you? (Select all that apply)',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value: 'None of these apply to me',
          key: 'none',
          uncheckOthers: true
        },
        {
          value: 'Pituitary or hypothalamic disease',
          key: 'pituitary_hypothalamic'
        },
        {
          value: 'Recent peripheral vision changes without a known cause',
          key: 'vision_changes'
        },
        { value: "I'm taking oral ketoconazole", key: 'ketoconazole' },
        {
          value: "I'm taking long term glucocorticoids such as prednisone",
          key: 'glucocorticoids'
        },
        { value: "I'm taking spironolactone", key: 'spironolactone' },
        {
          value: 'History of prostate cancer and/or elevated PSA',
          key: 'prostate_cancer_or_psa'
        },
        { value: 'History of breast cancer', key: 'breast_cancer' },
        { value: 'Polycythemia (elevated blood counts)', key: 'polycythemia' },
        {
          value: 'Untreated or severe sleep apnea',
          key: 'untreated_sleep_apnea'
        },
        {
          value: 'Advanced kidney disease and/or liver cirrhosis',
          key: 'advanced_kidney_or_liver'
        },
        { value: 'History of blood clots (DVT or PE)', key: 'blood_clots' },
        {
          value:
            'Uncontrolled heart failure (hospitalization within the last year for this)',
          key: 'heart_failure'
        },
        {
          value: 'Heart attack or stroke within the last 12 months',
          key: 'recent_mi_stroke'
        }
      ]
    }
  },
  {
    field: 'trtEnhanced_bloodPressure',
    label:
      'Blood pressure monitoring is important while on testosterone replacement therapy. What was your most recent blood pressure reading? Please select the closest range. If your top and bottom numbers fall into different ranges, choose the higher range. ',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Low: Less than 90/60', key: 'bloodPressure_low' },
        {
          value: 'Normal or mildly elevated: Less than 130/80',
          key: 'bloodPressure_normal'
        },
        { value: 'High: 130–159 or 80–99', key: 'bloodPressure_high' },
        {
          value: 'Very high: 160–179 or 100–119',
          key: 'bloodPressure_very_high'
        },
        {
          value: 'Severely high: 180 or higher, or 120 or higher',
          key: 'bloodPressure_severely_high'
        },
        { value: 'I do not remember', key: 'bloodPressure_do_not_remember' }
      ]
    }
  },
  {
    field: 'trtEnhanced_ltrsAgeRange',
    label: 'Select your appropriate age range?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Under 40', key: 'under_40_0' },
        { value: '40 or older', key: 'over_or_40_2' }
      ]
    }
  },
  {
    label: 'What is your:',
    field: 'trtEnhanced_weightHeightBmi',
    type: 'info',
    required: false,
    answer: {
      type: 'bmi',
      showLabel: true,
      bmiLabel: 'Your BMI is',
      heightLabel: 'Height',
      weightLabel: 'Weight'
    }
  },
  {
    field: 'trtEnhanced_HealthFactors',
    label: 'Which of the following apply to you? Select all that apply.',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value: 'I carry most of my weight in my abdomen (belly fat).',
          key: 'abdominal_weight_3'
        },
        {
          value: 'I have been diagnosed with Type 2 Diabetes.',
          key: 'type2_diabetes_3'
        },
        {
          value: 'I have been told I have prediabetes or insulin resistance.',
          key: 'prediabetes_2'
        },
        {
          value:
            'I have been diagnosed with high cholesterol or abnormal lipids.',
          key: 'high_cholesterol_2'
        },
        {
          value: 'I have been diagnosed with metabolic syndrome.',
          key: 'metabolic_syndrome_3'
        },
        {
          value: 'I have been diagnosed with obstructive sleep apnea.',
          key: 'sleep_apnea_3'
        },
        {
          value:
            'I snore loudly, feel excessively tired during the day, or someone has noticed pauses in my breathing during sleep.',
          key: 'sleep_breathing_symptoms_2'
        },
        {
          value: 'I work night shifts or rotating shifts.',
          key: 'shift_work_2'
        },
        {
          value: 'I have a poor diet (processed foods, high sugar)',
          key: 'poor_diet_1'
        },
        {
          value: 'I experience chronic stress.',
          key: 'chronic_stress_1'
        },
        {
          value: 'None of the above.',
          key: 'none_0',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    field: 'trtEnhanced_sleepApneaConsent',
    type: 'select',
    label:
      'TRT can worsen existing sleep apnea or reveal previously undiagnosed sleep apnea. If you notice increased snoring, gasping at night, morning headaches, excessive daytime fatigue, or if someone observes breathing pauses during your sleep, please notify us immediately. Untreated sleep apnea can lead to low nighttime oxygen levels and added strain on your heart. If you already have sleep apnea and are not consistently using your CPAP or other treatment, TRT may increase your risk of complications. Please keep us informed of any symptoms so we can ensure your treatment remains safe.',
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'I have read and understand this information and I do NOT wish to proceed',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value:
            'I have read and understand this information and I wish to proceed',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },
  {
    field: 'trtEnhanced_ltrsSleepHours',
    label: 'On average, how many hours of sleep do you get per night?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Less than 6 hours', key: 'lt6_2' },
        { value: '6-7 hours', key: '6_7_1' },
        { value: '7 or more hours', key: 'gte7_0' }
      ]
    }
  },
  {
    field: 'trtEnhanced_ltrsSleepQuality',
    label: 'How would you rate your sleep quality?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Poor (frequent awakenings, non-restorative)', key: 'poor_2' },
        { value: 'Fair', key: 'fair_1' },
        { value: 'Good', key: 'good_0' }
      ]
    }
  },
  {
    field: 'trtEnhanced_ltrsExerciseFrequency',
    label: 'How often do you exercise?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Rarely or never', key: 'rarely_1' },
        { value: '1-2 times per week', key: 'one_two_weekly_1' },
        { value: '3 or more times per week', key: 'three_plus_weekly_0' }
      ]
    }
  },
  {
    field: 'trtEnhanced_qadamLibido',
    label: 'How would you rate your libido (sex drive)?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Terrible', key: 'terrible_1' },
        { value: 'Poor', key: 'poor_2' },
        { value: 'Average', key: 'average_3' },
        { value: 'Good', key: 'good_4' },
        { value: 'Excellent', key: 'excellent_5' }
      ]
    }
  },
  {
    field: 'trtEnhanced_qadamEnergy',
    label: 'How would you rate your energy level?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Terrible', key: 'terrible_1' },
        { value: 'Poor', key: 'poor_2' },
        { value: 'Average', key: 'average_3' },
        { value: 'Good', key: 'good_4' },
        { value: 'Excellent', key: 'excellent_5' }
      ]
    }
  },
  {
    field: 'trtEnhanced_qadamStrengthEndurance',
    label: 'How would you rate your strength or endurance?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Terrible', key: 'terrible_1' },
        { value: 'Poor', key: 'poor_2' },
        { value: 'Average', key: 'average_3' },
        { value: 'Good', key: 'good_4' },
        { value: 'Excellent', key: 'excellent_5' }
      ]
    }
  },
  {
    field: 'trtEnhanced_qadamEnjoymentOfLife',
    label: 'How would you rate your enjoyment of life?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Terrible', key: 'terrible_1' },
        { value: 'Poor', key: 'poor_2' },
        { value: 'Average', key: 'average_3' },
        { value: 'Good', key: 'good_4' },
        { value: 'Excellent', key: 'excellent_5' }
      ]
    }
  },
  {
    field: 'trtEnhanced_qadamMood',
    label: 'How would you rate your overall happiness or mood?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Terrible', key: 'terrible_1' },
        { value: 'Poor', key: 'poor_2' },
        { value: 'Average', key: 'average_3' },
        { value: 'Good', key: 'good_4' },
        { value: 'Excellent', key: 'excellent_5' }
      ]
    }
  },

  {
    field: 'trtEnhanced_qadamErections',
    label: 'How strong are your erections?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Extremely weak', key: 'extremely_weak_1' },
        { value: 'Weak', key: 'weak_2' },
        { value: 'Moderate', key: 'moderate_3' },
        { value: 'Strong', key: 'strong_4' },
        { value: 'Extremely strong', key: 'extremely_strong_5' }
      ]
    }
  },
  {
    field: 'trtEnhanced_qadamWorkPerformance',
    label: 'How would you rate your work performance over the past 4 weeks?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Terrible', key: 'terrible_1' },
        { value: 'Poor', key: 'poor_2' },
        { value: 'Average', key: 'average_3' },
        { value: 'Good', key: 'good_4' },
        { value: 'Excellent', key: 'excellent_5' }
      ]
    }
  },
  {
    field: 'trtEnhanced_qadamSleepAfterDinner',
    label: 'How often do you fall asleep after dinner?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Never', key: 'never_1' },
        { value: '1-2 times per week', key: '1_2_weekly_2' },
        { value: '3-4 times per week', key: '3_4_weekly_3' },
        { value: '5-6 times per week', key: '5_6_weekly_4' },
        { value: 'Every night', key: 'every_night_5' }
      ]
    }
  },
  {
    field: 'trtEnhanced_qadamSportsPerformance',
    label:
      'How would you rate your sports or physical performance over the past 4 weeks?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Terrible', key: 'terrible_1' },
        { value: 'Poor', key: 'poor_2' },
        { value: 'Average', key: 'average_3' },
        { value: 'Good', key: 'good_4' },
        { value: 'Excellent', key: 'excellent_5' }
      ]
    }
  },
  {
    field: 'trtEnhanced_qadamHeightLost',
    label: 'How much height have you lost?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'None (0-0.4 inches)',
          key: 'none_zero_to_zero_four_inches_5'
        },
        { value: '0.5-0.9 inches', key: 'zero_five_to_zero_nine_inches_4' },
        { value: '1-1.4 inches', key: 'one_to_one_four_inches_3' },
        { value: '1.5-1.9 inches', key: 'one_five_to_one_nine_inches_2' },
        { value: '2 inches or more', key: 'two_or_more_inches_1' }
      ]
    }
  },
  {
    field: 'trtEnhanced_diagnosisStatus',
    label: 'Please select the option that best describes you:',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'I do NOT have a known diagnosis of low testosterone',
          key: 'new_patient'
        },
        {
          value:
            'I have a known diagnosis of low testosterone and I AM currently or have previously been on testosterone replacement therapy',
          key: 'continuation_patient'
        }
      ]
    }
  },
  {
    field: 'trtEnhanced_newPatientSymptomDuration',
    label:
      'How long have you been experiencing symptoms that you feel may be related to low testosterone?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'It has been around 1-6 months', key: '1_6_months' },
        { value: 'It has been 7-12 months', key: '7_12_months' },
        { value: 'It has been over a year', key: 'over_a_year' }
      ]
    }
  },
  {
    field: 'trtEnhanced_newPatientLifestyleChanges3MonthsNoImprovement',
    label:
      'Have you made consistent efforts to improve your symptoms through lifestyle changes for at least 3 months without meaningful improvement in your symptoms?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'Yes — I have made consistent lifestyle changes, but my symptoms have not improved or continue to limit my ability to maintain these changes',
          key: 'consistent_changes_no_improvement'
        },
        {
          value:
            'Yes — I have made consistent lifestyle changes with some improvement, but I still have significant symptoms',
          key: 'consistent_changes_some_improvement'
        },
        {
          value:
            'I have tried lifestyle changes, but have not been able to maintain them consistently due to my symptoms',
          key: 'tried_not_maintain'
        },
        {
          value: 'No — I have not yet made meaningful lifestyle changes',
          key: 'no_meaningful_changes'
        }
      ]
    }
  },
  {
    field: 'trtEnhanced_newPatientNormalLabPreference',
    label:
      "Your provider will review your labs, symptoms, and other health factors. It is important to know that some people have functional hypogonadism. In these cases, even if your testosterone level is within a normal range, it may not meet your body's needs. Your provider will consider all of this and discuss next steps with you. Your provider may also choose to initiate treatment on a trial basis to see if your symptoms improve. It may take 8 to 12 weeks to notice an effect. At your follow-up, your provider will assess your response and may either discontinue or continue treatment based on your progress.",
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'I understand and would still like to be considered for treatment if my lab levels remain within normal limits',
          key: 'consider_if_normal'
        },
        {
          value:
            'I understand and ONLY wish to continue treatment if my lab levels are low',
          key: 'only_if_low'
        }
      ]
    }
  },
  {
    field: 'trtEnhanced_continuationDiagnosisDuration',
    label: 'When were you first diagnosed with low testosterone?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'It has been less than 1 year', key: 'lt_1_year' },
        { value: 'It has been over 1-5 year', key: '1_5_years' },
        { value: 'It has been greater than 6 years now', key: 'gt_6_years' }
      ]
    }
  },
  {
    field: 'trtEnhanced_continuationCurrentMedicationDose',
    label:
      'What medication and dose are you CURRENTLY using for testosterone replacement? Please specify the formulation (e.g., injection, gel, or spray) and include the full concentration and amount used per dose. For example: Testosterone cypionate 200 mg/mL, injecting 0.25 mL per dose. (If you have been off of treatment, type NONE)',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'trtEnhanced_continuationCurrentMedicationDose'
    }
  },
  {
    field: 'trtEnhanced_continuationLastDoseDate',
    label:
      'Please enter the exact date you last administered your testosterone dose. Accurate timing helps us safely determine your next scheduled dose.',
    type: 'info',
    answer: {
      type: 'text',
      rows: 2,
      name: 'trtEnhanced_continuationLastDoseDate'
    }
  },
  {
    field: 'trtEnhanced_continuationMedicationDuration',
    label: 'How long have you been on your current medication?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Less than 3 months', key: 'lt_3_months' },
        { value: '3 – 6 months', key: '3_6_months' },
        { value: 'More than 6 months', key: 'gt_6_months' }
      ]
    }
  },
  {
    field: 'trtEnhanced_continuationResponseHappy',
    label: 'Are you happy with how you are responding to this medication?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'trtEnhanced_continuationResponseDetails',
    label: "Tell us more about what you're experiencing",
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'trtEnhanced_continuationResponseDetails'
    }
  },
  {
    field: 'trtEnhanced_continuationSideEffects',
    label:
      'Are you experiencing any of the following since starting or adjusting TRT?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value: 'Increased hematocrit/polycythemia',
          key: 'polycythemia'
        },
        {
          value:
            'Has a provider suggested that you donate blood in order to reduce your blood count',
          key: 'provider_suggested_donation'
        },
        { value: 'Mood swings or depression', key: 'mood_changes' },
        { value: 'Acne or oily skin', key: 'acne_oily_skin' },
        { value: 'Worsening sleep apnea', key: 'worsening_sleep_apnea' },
        {
          value: 'Injection-site discomfort',
          key: 'injection_site_discomfort'
        },
        { value: 'No notable side effects', key: 'none', uncheckOthers: true },
        {
          value: 'I have experienced other side effects',
          key: 'other'
        }
      ]
    }
  },
  {
    field: 'trtEnhanced_continuationOtherSideEffects',
    label: 'Tell us more about your other side effects',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'trtEnhanced_continuationOtherSideEffects'
    }
  },
  {
    field: 'trtEnhanced_continuationPastComplications',
    label:
      'Have you ever had side effects or complications to other TRT products?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes, I have had other issues', key: 'yes' },
        { value: "No, I haven't had any other issues", key: 'no' }
      ]
    }
  },
  {
    field: 'trtEnhanced_continuationPastComplicationsDetails',
    label:
      'Tell us more about what you have experienced including the reaction and which medication caused this reaction',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'trtEnhanced_continuationPastComplicationsDetails'
    }
  },
  {
    field: 'trtEnhanced_continuationAdjustmentPreference',
    label: 'Would you like to adjust your dose or formulation?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: "No, I'm satisfied with my current therapy",
          key: 'no_change'
        },
        { value: "Yes, I'm concerned about side effects", key: 'side_effects' },
        {
          value: "Yes, I'm seeking improved symptom control",
          key: 'improve_control'
        },
        { value: "I'm unsure, please advise", key: 'unsure' }
      ]
    }
  },
  {
    field: 'trtEnhanced_continuationHasLabResults',
    label: 'Do you have testosterone lab images from the past 4 months?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    },
    extras: {
      sendToBeluga: false
    }
  },
  {
    field: 'trtEnhanced_continuationLabResultsTooHigh',
    label: `If you’re on treatment, do your labs show that your testosterone was too high?`,
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes, my testosterone value has been too high', key: 'yes' },
        {
          value: 'No my testosterone value was low or within my expected range',
          key: 'no'
        },
        { value: 'I don’t know the results', key: 'dont_know' }
      ]
    }
  },
  {
    field: 'trtEnhanced_continuationInitialLabsUpload',
    label: 'Image Request:',
    educationalSlide:
      'To ensure the highest quality of care during your telemedicine consultation, we kindly request your assistance in providing an image of your initial or most recent labs obtained upon diagnosis that demonstrate your testosterone levels. Please be assured that these images will remain private and will not be shared. The physician will use the picture solely for assessment purposes to better understand your health condition. If you are unable to upload recent lab results OR if your labs were abnormal, you will be required to complete blood testing before proceeding with treatment. Thank you for your cooperation and understanding in helping to provide comprehensive care remotely.',
    type: 'file_upload',
    accepts: ['application/pdf', 'image/png', 'image/jpeg'],
    answer: [
      {
        resourceId: 'trtEnhanced_continuationInitialLabsUpload',
        buttonLabel: 'Upload Image'
      }
    ]
  },
  {
    field: 'trtEnhanced_questionsForDoctor',
    label: 'What other information or questions do you have for the doctor?',
    type: 'info',
    answer: { type: 'text', rows: 4, name: 'trtEnhanced_questionsForDoctor' }
  },
  {
    field: 'trtEnhanced_treatmentConsent',
    label: 'TRT, HCG, and SERM-Based Therapy Informed Consent',
    type: 'select',
    educationalSlide: `You are requesting evaluation and possible treatment for symptoms related to low testosterone. Treatment options may include:
- Testosterone Replacement Therapy (TRT)
- Human Chorionic Gonadotropin (HCG)
- Selective Estrogen Receptor Modulators (SERMs) such as clomiphene or enclomiphene
- Aromatase inhibitors (AIs) when clinically appropriate

These therapies may be used alone or in combination depending on your symptoms, laboratory results, and treatment goals (including fertility preservation).

TRT may be administered as an injection, gel, oral regimen, cream, or nasal formulation. HCG, SERMs, and AIs are oral or injectable therapies used to stimulate or regulate endogenous hormone production. All treatment is prescribed and monitored by a licensed healthcare provider.

Potential Benefits
Treatment may improve:
- Energy, libido, and sexual function
- Muscle mass, strength, and exercise tolerance
- Mood and overall well-being
HCG and SERMs may help stimulate natural testosterone production and support fertility in some patients.

Risks and Side Effects
TRT:
- Acne, oily skin
- Fluid retention
- Mood changes
- Testicular shrinkage and reduced sperm production
- Elevated red blood cell count
HCG:
- Injection site irritation
- Headache or mood changes
- Gynecomastia
- Increased estrogen levels
Clomiphene / Enclomiphene (SERMs):
- Headache
- Mood changes
- Visual disturbances (rare but important)
- Possible liver or lipid changes
Aromatase Inhibitors (AIs):
- Joint pain
- Fatigue
- Low estrogen symptoms (e.g., mood or libido changes)
- Decreased bone density with long-term use
Serious (rare) risks:
- Elevated hematocrit
- Cardiovascular events (clot, stroke, heart attack)
- Worsening sleep apnea
- Liver abnormalities
- Allergic reactions
Seek emergency care for chest pain, shortness of breath, severe headache, or leg swelling.

Fertility Considerations
- TRT may suppress sperm production and lead to infertility
- HCG and SERMs may help preserve or stimulate fertility, but this is not guaranteed

Compounded Medications
Some therapies may be compounded and not FDA-approved. These may be used when clinically appropriate; however, comparative safety and efficacy data may be limited.

Contraindications
You must disclose any history of:
- Prostate or breast cancer
- Polycythemia
- Severe heart disease or recent stroke
- Untreated sleep apnea
- Allergy to any prescribed therapy

Monitoring Requirements
Ongoing treatment requires periodic labs (typically every 3–6 months), which may include:
- CBC (hematocrit)
- Testosterone levels
- PSA (when appropriate)
- Liver function and lipids
- Estradiol (when indicated)
Failure to complete required monitoring may result in dose adjustment or discontinuation.

Alternatives
- No treatment
- Lifestyle optimization (sleep, exercise, weight loss)
- Non-hormonal therapies
- HCG or SERMs alone (fertility-focused approaches)

Truthfulness and Accuracy of Information
I acknowledge that the safety and appropriateness of my treatment depend on the accuracy and completeness of the information I provide. I confirm that:
- All medical history, medications, allergies, and symptoms I have provided are true, accurate, and complete to the best of my knowledge
- I will update my provider if there are any changes to my health, medications, or symptoms
- I understand that failure to provide accurate or complete information may increase my risk of adverse outcomes and may result in discontinuation of care

Acknowledgment and Consent
I understand:
- The risks, benefits, and alternatives of TRT, HCG, SERMs, and AIs
- No outcomes are guaranteed
- Ongoing monitoring is required
- My treatment may be modified or discontinued for safety

I consent to evaluation and treatment under medical supervision.
`,
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'I have read the above information and I do NOT wish to continue',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value:
            'I have read the above information and I do consent and wish to move forward',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },

  // ======= Old LTRS Questions, Merged into one. Keeping here for backwards compatibility =======
  {
    field: 'trtEnhanced_ltrsAbdominalWeight',
    label: 'Do you carry most of your weight in your abdomen (belly fat)?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes_3' },
        { value: 'No', key: 'no_0' }
      ]
    }
  },
  {
    field: 'trtEnhanced_ltrsType2Diabetes',
    label: 'Have you been diagnosed with Type 2 Diabetes?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes_3' },
        { value: 'No', key: 'no_0' }
      ]
    }
  },
  {
    field: 'trtEnhanced_ltrsPrediabetes',
    label: 'Have you been told you have prediabetes or insulin resistance?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes_2' },
        { value: 'No', key: 'no_0' }
      ]
    }
  },
  {
    field: 'trtEnhanced_ltrsHighCholesterol',
    label: 'Have you been diagnosed with high cholesterol or abnormal lipids?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes_2' },
        { value: 'No', key: 'no_0' }
      ]
    }
  },
  {
    field: 'trtEnhanced_ltrsMetabolicSyndrome',
    label: 'Have you been diagnosed with metabolic syndrome?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes_3' },
        { value: 'No', key: 'no_0' }
      ]
    }
  },
  {
    field: 'trtEnhanced_ltrsSleepApneaDiagnosis',
    label: 'Have you been diagnosed with obstructive sleep apnea?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes_3' },
        { value: 'No', key: 'no_0' }
      ]
    }
  },
  {
    field: 'trtEnhanced_ltrsSleepBreathingSymptoms',
    label:
      'Do you snore loudly, feel excessively tired during the day, or has anyone noticed pauses in your breathing during sleep?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes_2' },
        { value: 'No', key: 'no_0' }
      ]
    }
  },
  {
    field: 'trtEnhanced_ltrsShiftWork',
    label: 'Do you work night shifts or rotating shifts?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes_2' },
        { value: 'No', key: 'no_0' }
      ]
    }
  },
  {
    field: 'trtEnhanced_ltrsDietQuality',
    label: 'How would you describe your diet?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Poor (processed foods, high sugar)', key: 'poor_1' },
        { value: 'Average or healthy', key: 'average_or_healthy_0' }
      ]
    }
  },
  {
    field: 'trtEnhanced_ltrsChronicStress',
    label: 'Do you experience chronic stress?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes_1' },
        { value: 'No', key: 'no_0' }
      ]
    }
  }
] as const;

const _type = trtEnhancedInitialQuestions;
export type TRTEnhancedQuestionFieldAnswers = Partial<
  QuestionAnswerMap<typeof _type>
>;

export default trtEnhancedInitialQuestions;
